module.exports = __webpack_public_path__ + "media/post-listing-cta-background@2x.57358dd5.webp";